export default __webpack_public_path__ + "images/0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e.png";